import classNames from 'classnames';
import { useMemo } from 'react';
import { useDrop } from 'react-dnd';
import { HexUtils } from '../HexGrid';
import './GameBoardTileHtml.css';

export function GameBoardTileHtml(props) {
  const {
    theme,
    board,
    handleKeyDown,
    handleClick,
    gridItemProps,
    hex,
    ariaLabel,
  } = props;

  const [{ isOver }, dropRef] = useDrop(
    () => ({
      accept: 'piece',
      drop: () => ({
        name: hex.id,
        data: hex,
      }),
      canDrop: (item) => {
        return item.data.solved === false;
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [hex]
  );

  const { layout } = gridItemProps;
  const pixel = useMemo(() => HexUtils.hexToPixel(hex, layout), [hex, layout]);
  const backgroundStyles = useMemo(() => {
    if (!gridItemProps.ready) return {};
    const { tile, boardImageBCR, boardImageOffset } = gridItemProps;
    const backgroundPositionX = `-${
      pixel.x * tile.scale + boardImageOffset.x
    }px`;
    const backgroundPositionY = `-${
      pixel.y * tile.scale + boardImageOffset.y
    }px`;
    const newStyles = {
      background: `
      url(${theme.hexCoverStroke}) 0 0 no-repeat,
      url(${theme.hexCoverImg}) 0 0 no-repeat,
      url(${board.boardImg}) ${backgroundPositionX} ${backgroundPositionY} no-repeat
        `,
      backgroundSize: `contain, contain, ${boardImageBCR.width}px ${boardImageBCR.height}px`,
      backgroundBlendMode: 'color',
    };
    return newStyles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridItemProps.tile, pixel.x, pixel.y]);

  const styles = useMemo(() => {
    if (!gridItemProps.ready) return {};
    const { tile } = gridItemProps;
    let newStyles = {
      width: tile.width,
      height: tile.height,
      transform: `translate(${pixel.x * tile.scale}px, ${
        pixel.y * tile.scale
      }px)`,
    };

    if (!hex.solved) {
      newStyles = { ...newStyles, ...backgroundStyles };
    }

    return newStyles;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridItemProps.tile, pixel.x, pixel.y, hex.solved]);

  return (
    <div
      id={`${hex.id}-dropzone`}
      className={classNames('dropzone', { solved: hex.solved, hover: isOver })}
      role="gridcell"
      tabIndex={-1}
      data-pixel-x={pixel.x}
      data-pixel-y={pixel.y}
      data-solved={hex.solved}
      aria-rowindex={hex.gridItem?.row}
      aria-colindex={hex.gridItem?.col}
      style={{
        ...styles,
      }}
    >
      <button
        tabIndex={0}
        ref={dropRef}
        className="dropzone-btn"
        id={`${hex.id}-dropzone-btn`}
        value={hex.id}
        data-x={hex.gridItem?.col - 1}
        data-y={hex.gridItem?.row - 1}
        aria-label={ariaLabel}
        onKeyDown={handleKeyDown}
        onMouseDown={handleClick}
        onClick={handleClick}
      />
    </div>
  );
}
